import { render, staticRenderFns } from "./DefaultQuestionType.vue?vue&type=template&id=730f8db6&scoped=true"
import script from "./DefaultQuestionType.vue?vue&type=script&lang=js"
export * from "./DefaultQuestionType.vue?vue&type=script&lang=js"
import style0 from "./DefaultQuestionType.vue?vue&type=style&index=0&id=730f8db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730f8db6",
  null
  
)

export default component.exports